<template>
  <div class="padlet-browser side-panel side-panel-with-curtain" @click.self="close">
    <div
      :class="[
        'panel-container',
        'is-animated',
        'slide-from-right',
        xNewSurfaceShadows ? 'shadow-elevation-3' : 'shadow-z3',
      ]"
    >
      <header class="panel-header panel-header-with-content">
        <div class="panel-left-item">
          <button class="text-button narrow-button" @click="close">{{ __('Close') }}</button>
        </div>
        <div class="panel-title">{{ __('Padlets') }}</div>
        <div class="panel-right-item" />
      </header>
      <SurfacePadletPicker
        class="pt-2 flex-grow flex-shrink-0 max-h-full"
        :filter-tabs="filterTabs"
        :active-filter-index="activeFilterIndex"
        @select-filter="selectFilter"
        @select-wall="selectWall"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import SurfacePadletPicker from 'vuecomponents/SurfacePadletPicker.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { SurfacePadletPicker },
  mixins: [EscapeToCancelMixin],
  props: ['user', 'xNewSurfaceShadows'],
  data() {
    return {
      activeFilterIndex: 0,
    }
  },
  computed: {
    ...mapGetters(['viewableLibraries', 'isOrgWall', 'tenantName']),
    filterTabs() {
      const viewableLibrariesFilters = this.viewableLibraries.map((library) => {
        return {
          text: library.name || library.slug,
          accountKey: { type: 'library', id: library.id },
          collectionKey: {
            typeKey: 'filter',
            indexKey: 'all',
          },
        }
      })

      const globalAndPersonalCollections = [
        {
          text: this.__('Recents'),
          accountKey: { type: 'user', id: this.user.id },
          collectionKey: {
            typeKey: 'filter',
            indexKey: 'combined_recents',
          },
        },
        {
          text: this.__('Bookmarks'),
          accountKey: { type: 'user', id: this.user.id },
          collectionKey: {
            typeKey: 'filter',
            indexKey: 'favorites',
          },
        },
      ]
      if (this.isOrgWall) {
        globalAndPersonalCollections.push(
          {
            text: this.tenantName,
            accountKey: { type: 'user', id: this.user.id },
            collectionKey: {
              typeKey: 'filter',
              indexKey: 'all',
            },
          },
          {
            text: this.user.short_name,
            accountKey: { type: 'user', id: this.user.id },
            collectionKey: {
              typeKey: 'filter',
              indexKey: 'made',
            },
          },
        )
      } else {
        globalAndPersonalCollections.push(
          {
            text: this.user.short_name,
            accountKey: { type: 'user', id: this.user.id },
            collectionKey: {
              typeKey: 'filter',
              indexKey: 'all',
            },
          },
          {
            text: this.__('Shared'),
            accountKey: { type: 'user', id: this.user.id },
            collectionKey: {
              typeKey: 'filter',
              indexKey: 'combined_shared',
            },
          },
        )
      }

      return [...globalAndPersonalCollections, ...viewableLibrariesFilters]
    },
  },
  mounted() {
    this.fetchViewableLibraries({ userId: this.user.id })
  },
  methods: {
    ...mapActions(['fetchViewableLibraries']),
    cancel() {
      this.close()
    },
    close() {
      this.$emit('close')
    },
    selectFilter(filterIndex) {
      this.activeFilterIndex = filterIndex
    },
    selectWall(wall) {
      this.$emit('select', wall.links.permanent)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.padlet-browser-messages {
  flex-grow: 1;
  padding: 32px;
  font-size: $big-body-font-size;
  line-height: $big-body-line-height;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.padlet-browser-empty-message {
  background-image: url(../images/cactus_mobile.png);
  background-size: contain;
  background-position: bottom right;
  background-repeat: no-repeat;
}
</style>
